<template>
  <PopupXSmall
    v-if="alertStore.visible && mode === 'default'"
    :title="alertStore.messages.title"
    :is-visible-button-close="alertStore.clickSelfToClose"
    @close="closeByButton"
  >
    <div class="modal-body">
      <p class="semibold tit01 pdb-1" v-html="alertStore.messages.title"></p>
      <p class="semibold tit02" v-html="alertStore.messages.bodyAccentTitle"></p>
      <p class="mt-3" v-html="alertStore.messages.message"></p>
      <p v-html="alertStore.messages.subMessage"></p>
    </div>

    <div class="modal-footer">
      <button class="gray-btn l-btn" v-if="alertStore.cancelAction !== null" @click="cancel">
        {{ $t(alertStore.cancelButtonName) }}
      </button>
      <ButtonProcess
        full-width
        :class="{
          'w-p100': alertStore.cancelAction === null,
        }"
        :loading="processing"
        @click="confirm"
        @keydown.enter="confirm"
      >
        {{ alertStore.confirmButtonName }}
      </ButtonProcess>
    </div>
  </PopupXSmall>
</template>

<script lang="ts" setup>
import { computed, ref } from 'vue';

import ButtonProcess from '@/components/shared/base/ButtonProcess.vue';
import PopupXSmall from '@/components/shared/composite/PopupXSmall.vue';
import { useAlertStore } from '@/stores/alert';
import { AlertMode } from '@/types/components.js';

/***
 사용법:
 1. alertStore와 함께 사용
 2. alertStore.cancelAction === null 일 경우 확인버튼만 노출
 3. alertStore의 confirmAction, cancelAction, title, bodyTitle, message, bodyAccentTitle, subMessage 사용
 */

const alertStore = useAlertStore();
const processing = ref(false);

const mode = computed<AlertMode>(() => {
  return alertStore.alertMode;
});

const close = () => {
  alertStore.close();
};

const confirm = async () => {
  if (processing.value) {
    return;
  }
  processing.value = true;
  await alertStore.confirmAction();
  processing.value = false;
  close();
};

const cancel = async () => {
  await alertStore.cancelAction();
  close();
};

function closeByButton() {
  if (alertStore.clickSelfToClose) {
    close();
  }
}
</script>

<style lang="scss" scoped>
.modal-body {
  text-align: center;
  p {
    word-break: break-all;
    &.tit01 {
      font-size: $font-size-h5;
    }
    &.tit02 {
      font-size: $font-size-h6;
    }
  }
}

.modal-footer {
  display: flex;
  margin-top: 1.5rem;
  gap: 0.5rem;
}

@media (min-width: 768px) {
  .modal-content {
    width: 25rem;
  }
}
</style>
